import MetaControl from 'Components/UI/Meta/MetaControl';
import React, { useState } from 'react';
import useResource from 'Hooks/useResource';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDStack,
} from '@facet-wealth/design';
import { TextInputLarge } from 'Packages/FacetDesign/Components';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useDebounceWithCallback from 'Hooks/useDebounceWithCallback';
import { dataAttrs } from 'Helpers/Testing';
import {
  useTaxDiagnosticSummaryContext,
} from 'Views/Page/Content/Templates/TaxDiagnosticTaxStrategiesSummaryStep/TaxDiagnosticSummaryContext';


const metaOverrides = buildFacetDesignOverride()
  .nameOverride('question', {
    _component: () => TextInputLarge,
    _customProps: {
      rows: 5,
    },
  })
  .done();

export const TaxDiagnosticQuestion = ({ resource }) => {
  const [warningText, setWarningText] = useState('');
  const [hasSaved, setHasSaved] = useState(false);

  const { questionsSaving, onSaveStarted, onSaveComplete } = useTaxDiagnosticSummaryContext();

  const onSaveSuccess = () => {
    setHasSaved(true);
    setTimeout(() => {
      setHasSaved(false);
    }, 2000);
  };

  const {
    resource: questionResource,
    setAttribute,
  } = useResource(resource);

  const handleSave = async () => {
    onSaveStarted(questionResource.attr('strategyType'));
    setWarningText('');
    try {
      await questionResource.link('self').put();
      onSaveSuccess();
    } catch (err) {
      if (err.errors && err.errors.length > 0) {
        setWarningText(err.errors[0].shortDetail);
      } else {
        setWarningText('Failed to save question');
      }
    } finally {
      onSaveComplete(questionResource.attr('strategyType'));
    }
  };

  const debouncedRequest = useDebounceWithCallback(handleSave, 500, []);

  const handleChange = (val) => {
    setAttribute('question', val);

    debouncedRequest(val);
  };

  const getLabelText = () => {
    if (warningText) {
      return warningText;
    }
    if (questionsSaving.has(questionResource.attr('strategyType'))) {
      return 'Saving...';
    }
    if (hasSaved) {
      return 'Saved!';
    }
    return '';
  };


  return (
    <FDStack direction={'column'} alignItems={'flex-start'} spacing={1}>
      <MetaControl
        resource={questionResource}
        metaOverrideSet={metaOverrides}
        attrName={'question'}
        value={questionResource.attr('question')}
        onChange={(val) => handleChange(val)}
        fullWidth
        helperText={getLabelText()}
        {...dataAttrs('tax-diagnostic-question', questionResource)}
      />
    </FDStack>
  );
};

TaxDiagnosticQuestion.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
